import React, { useState, useEffect } from "react";
import { fetchGet } from "../../../client";
import { APIResponse } from "../../../types/responses/APIResponse";
import RAccordion from "../../RAccordion/RAccordion";
import RAccordionLoader from "../../States/Loading/Loaders/shared/RAccordionLoader";
import { useAtom } from "jotai";
import { globalFullscreenAtom } from "../../../atoms";
const FaqList = ({ id, isAttachment }) => {
  const [faqs, setFaqs] = useState([]);
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(true);
  const [globalFullscreen] = useAtom(globalFullscreenAtom);
  type Faq = { title: string; content: string };
  type AllFaqs = { list: { items: Faq[] } };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res: APIResponse<AllFaqs> = await fetchGet(`faqs/lists/${id}`);
        setFaqs(res.list.items);
      } catch (err) {
        setError("Error loading FAQs: " + err?.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <RAccordionLoader />;
  if (error || !faqs.length) return null;

  return (
    <>
      {!globalFullscreen &&
        faqs.map((faq, idx) => (
          <RAccordion
            key={idx}
            isAttachment={isAttachment}
            text={faq.title}
            content={faq.content}
          />
        ))}
    </>
  );
};

export default FaqList;
